module.exports = __webpack_public_path__ + "flag-outline.3XZeCp21.svg";